export interface TimeSlotInit {
  lesson_id: string;
  capacity: number;
  vacancy: number;
  accepted: number;
  pending: number;
  recurrence_key: string;
  start_at: number;
  end_at: number;
}

export default class TimeSlot {
  public readonly lessonId: string;
  public readonly capacity: number;
  public readonly vacancy: number;
  public readonly accepted: number;
  public readonly pending: number;
  public readonly recurrenceKey: string;
  public readonly startAt: number;
  public readonly endAt: number;

  constructor(init: TimeSlotInit) {
    this.lessonId = init.lesson_id;
    this.capacity = init.capacity;
    this.vacancy = init.vacancy;
    this.accepted = init.accepted;
    this.pending = init.pending;
    this.recurrenceKey = init.recurrence_key;
    this.startAt = init.start_at;
    this.endAt = init.end_at;
  }
}
